import { recordAction, onRepeatedAction, ACTIONS } from './RepeatedActionService';
const RepeatedActionService = { recordAction, onRepeatedAction, ACTIONS };
export default RepeatedActionService;
